

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {namespace} from "vuex-class";

  import {PermissionHelper} from "@/helpers/PermissionHelper";
  import {EUserPermissions} from "@/model/EUserPermissions";
  import UPDialog from "@/components/user/permissions/UPDialog.vue";
  import {IAuthUserData} from "@/store/modules/authModule";
  import {BoListPanel, BoPanel} from "bonomo/dist";
  import CreateButton from "@/components/shared/CreateButton.vue";
  import {IShortUser} from "@/model/shortInterfaces";
  import UserSearch from "@/components/user/widget/UserSearch.vue";
  import UserNav from "@/components/user/widget/UserNav.vue";
  import {Prop} from "vue-property-decorator";
  import LinkChip from "@/components/shared/chips/LinkChip.vue";
  import {IUserPermission} from "@/store/modules/user/usersPromotionModule";
  import Datim from "@/components/shared/Datim.vue";
  import PermissionTargetChip from "@/components/shared/chips/PermissionTargetChip.vue";
  import UserChip from "@/components/shared/chips/UserChip.vue";
  import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";

  const authModule = namespace("authModule");
  const permissionsModule = namespace("permissionsModule");
  const userPermissionModule = namespace("userPermissionModule");

  @Component({
    name: 'UserPermissions',
    components: {
      BoPanel,
      BoListPanel,
      UserChip,
      Datim,
      LinkChip,
      UPDialog,
      CreateButton,
      UserSearch,
      UserNav,
      PermissionTargetChip,
    }
  })
  export default class UserPermissionsView extends Vue {

    @Prop()
    protected userId?: number;

    @authModule.Getter('userData')
    protected authUser!: IAuthUserData;
    @userPermissionModule.Action('cleanErrors')
    protected cleanErrors!: () => void;
    @userPermissionModule.Getter('permissions')
    protected permissions!: IUserPermission[];
    @permissionsModule.Getter('permissionTargets')
    private permissionTargets!: string[];
    @userPermissionModule.Getter('permissionsUser')
    protected user!: IAuthUserData;

    @userPermissionModule.Action('fetchPermissions')
    protected fetchPermissions!: (userId: number) => Promise<any>;
    @userPermissionModule.Action('fetchPermissionsUser')
    protected fetchPermissionsUser!: (userId: number) => Promise<any>;

    get isSelf() {
      return '' + this.$route.params.userId === '' + this.authUser.id;
    }
    get canEdit() {
      const userData = this.authUser;
      const isDeveloper = PermissionHelper.hasPermission(userData, EUserPermissions.PERMISSION_DEVELOPER, 0);

      if (isDeveloper) {
        return true;
      }
      
      if (this.isSelf && !this.isDev) {
        return false;
      }

      return PermissionHelper.hasPermissionAny(userData, EUserPermissions.PERMISSION_PERMISSIONS) || isDeveloper;
    }
    get isDev() {
      return process.env.NODE_ENV == 'development' ||
          document.location.hostname.indexOf('staging.') !== -1;
    }

    protected loading: boolean = true;
    protected get headers(): BetterDataTableHeader[] {
      return [
        { text: this.$t('users.userPermissions.fields.permission'), align: 'start', sortable: true, value: 'permission' },
        { text: this.$t('users.userPermissions.fields.target'), align: 'start', value: 'target' },
        { text: this.$t('users.userPermissions.fields.granted_by'), align: 'start', value: 'granted_by' },
        { text: this.$t('users.userPermissions.fields.from'), align: 'start', value: 'created_at' },
        { text: '', value: 'control' },
      ];
    }

    // load the user of whose permissions this page is about
    private loadData() {
      this.fetchPermissionsUser(this.userId as number);
    }
    // load the permissions
    private loadPermissions() {
      this.fetchPermissions(this.userId as number);
    }

    private onGotoUser(user: IShortUser) {
      if (user.id !== parseInt(this.$route.params.userId)) {
        this.$router.push({name: 'userPermissions', params: {userId: ''+user.id}});
        this.loadData();
      }
    }
    private onCreate() {
      this.cleanErrors();
      this.$uiBus.emit('up-dialog.show');
    }
    private onRemove(permission: any) {
      // NOTE this will automatically trigger "loading" as we use the same "permissionsLoaded" mutationName
      this.$store.dispatch('userPermissionModule/removePermission', {
        userId: this.userId,
        permission: permission.permission,
        target_id: permission.target_id,
      });
    }
  }
